import { theme } from 'antd';
import { DeviceGroupsIcon, DevicesIcon, TeamIcon, UserIcon } from 'assets/images/svg';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAssetGroups } from 'reduxStore/assetGroups/selectors';
import { selectDevices } from 'reduxStore/devices/selectors';
import { selectFloors } from 'reduxStore/floors/selectors';
import { selectPeople } from 'reduxStore/people/selectors';
import { selectTeams } from 'reduxStore/teams/selectors';
import { Card, Col, Row, Space, Typography } from 'zui/Antd';

const { Title } = Typography;

const SiteStatistics = ({ selectedSite }) => {
	// hooks
	const {
		token: { paddingXL, colorPrimary, borderRadiusLG, colorBorder }
	} = theme.useToken();
	// Redux store data
	const people = useSelector(selectPeople)?.filter((p) => p?.siteID === selectedSite);
	const team = useSelector(selectTeams)?.filter((t) => t?.siteID === selectedSite);
	// 1) grab all floors in this site
	const floorIDs = useSelector(selectFloors)
		?.filter((f) => f?.siteID === selectedSite)
		?.map((f) => f?.floorID);

	const device = useSelector(selectDevices);
	const devicesOnSite = useMemo(
		() => device?.filter((d) => d?.location?.some((loc) => floorIDs?.includes(loc?.floorID))),
		[device, floorIDs]
	);
	const deviceGroup = useSelector(selectAssetGroups).filter((g) => g.siteID === selectedSite);

	// Stats cards data
	const statsCards = [
		{
			title: 'People',
			count: people.length,
			icon: <UserIcon width={50} height={50} color={colorPrimary} />
		},
		{
			title: 'Teams',
			count: team.length,
			icon: <TeamIcon width={50} height={50} color={colorPrimary} />
		},
		{
			title: 'Connected Devices',
			count: devicesOnSite?.length,
			icon: <DevicesIcon width={50} height={50} color={colorPrimary} />
		},
		{
			title: 'Device Groups',
			count: deviceGroup.length,
			icon: <DeviceGroupsIcon width={50} height={50} color={colorPrimary} />
		}
	];

	return (
		<Row gutter={[0, 16]} style={{ marginBottom: paddingXL }}>
			<Col span={24}>
				<Card style={{ borderRadius: borderRadiusLG, border: `1px solid ${colorBorder}` }}>
					<Row gutter={[48, 16]} justify='space-between'>
						{statsCards.map((stat, index) => (
							<Col
								key={index}
								xs={24} // 1 per row on small
								md={12} // 2 per row on medium
								lg={6} // all in one row on large
							>
								<Space align='center'>
									{stat.icon}
									<div>
										<Title level={5} style={{ margin: 0, fontSize: 14 }}>
											{stat.title}
										</Title>
										<Title level={3} style={{ margin: 0, fontSize: 20 }}>
											{stat.count}
										</Title>
									</div>
								</Space>
							</Col>
						))}
					</Row>
				</Card>
			</Col>
		</Row>
	);
};

export default SiteStatistics;
